import { useDispatch, useSelector } from "react-redux"
import { ActionCL } from "../interfaces/comprobante-liquidacion.interface"
import { NOTA_REMISION_TYPES } from "../constants/nota-remision-types"
import { State } from "../reducers"
import { REGEX_EMAIL, REGEX_INTEGER, REGEX_LETRAS_ESPACIOS, REGEX_LETRAS_ESPACIOS_NUMS, REGEX_LETTERS, REGEX_NIT, REGEX_NRC } from "../constants/Regex"
import * as http from '../api/http'
import { ENDPOINTS } from "../api/config"
import { KEYS } from "../constants/keysStorage"
import { generalOpenConfirmEdit, generalOpenModalError, generalOpenModalInfo, generalOpenModalMessage, generalOpenToastError, generalOpenToastInfo, generalOpenToastSuccess, generalShowLoader } from "./general.actions"
import { useEffect, useState } from "react"
import { docsAsociadosReset, docsDatosReceptorSiguienteDispatch } from "./documentos/documentos.actions"

import FlechaDerechaIcon from '../media/felsv/white_right-arrow_icon.svg'
import EmitirIcon from '../media/felsv/white_check_icon.svg'
import MasOpcionesIcon from '../media/felsv/WhiteOpciones.svg'
import { getEmailNotifyMsg, unirChipsJoin, unirChipsReturnFirst, validarRegexLetras, validarRegexNumericoFloat2Decimales, validarRegexNumericoInt } from "../utils/strings.utils"
import { getMunicipios } from "./catalogos.actions"
import { validarTipoDocumento } from "../utils/validaciones"
import { facturacionGetUUID } from "./facturacion/facturacionEmision.actions"
import { convertDateFormatAnular, getFechaFormato1 } from "../utils/stringDate"
import { anularFactura_DTE, descargarJson, generateQRImageFromBits, getExcelFactura, getFacturaImage, getFacturaPDF_New, getQR, sendTransactionEmail } from "./operaciones/operaciones.actions"
import { useHistory } from "react-router-dom"
import { OPSendEmail } from "../interfaces/operaciones.interface"
import { COMPROBANTE_LIQUIDACION_TYPES } from "../constants/comprobante-liquidacion.types"

export default function useComprobanteLiquidacion () {
    const {formCliente, errorsCliente, productos, view, productoIndex, response_Emitir, clienteEncontrado, documentosAsociados, formBusquedaDocumento, errorsFormBusquedaDocumento, mostrarDetalle, formDocumentoFisico, errorsDocumentoFisico, modal_editarDocumentoFisico, documentoFisicoEdit} = useSelector((state: State) => state.comprobanteLiquidacion)
    const {departamentos, actividadesEconomicas, datosEmisor, tipoDocumentosEmision} = useSelector((state: State) => state.catalogos)
    const {datosUUID} = useSelector((state: State) => state.facturacion)
    const datosReceptor = useSelector((state: State) => state.documentos.datosReceptor.form);

    const dispatch = useDispatch()
    const history = useHistory()
    const emisorGranContribuyente = datosEmisor?.tipoContribuyente === '1'
    const emisorJuridico = datosEmisor?.tipoEmpresa === '1'
    const {datos} = useSelector((state: State) => state.userLogin)

    const cargarDatosIniciales = () => {
        let fechaActual = new Date().toISOString().split('T')[0]
        let sucursalConDocumento = formCliente?.datosSucursal?.find((suc: any) => suc.Documento.find((doc: any) => doc.iddocumento === '8'))
        let documentoSucursal = sucursalConDocumento?.Documento.find((doc: any) => doc.iddocumento === '8')

        dispatch(handleSetFormCliente({
            ...formCliente,
            fecha: fechaActual,
            sucursal: sucursalConDocumento?.idsucursal,
            serie: documentoSucursal?.idsucursaldocumento
        })) 
    }

    const onChangeFormDocumentoFisico = (field: string, value: any) => {
        console.log(field, value);
        
        if(!validateChange(field, value) && value.trim() !== '') return
        dispatch(handleSetFormDocumentoFisico({...formDocumentoFisico, [field] : value}))
        validateFormDocumentoFisico(field, value)
    }

    const onChangeFormCliente = (field: string, value: any) => {
        if(!validateChange(field, value) && value.trim() !== '') return
        dispatch(handleSetFormCliente({...formCliente, [field] : value}))
        validateFormCliente(field, value)
    }

    const onChangeFormBusquedaDocumento = (field: string, value: any) => {
        if(!validateChange(field, value) && value.trim() !== '') return
        dispatch(handleSetFormBusquedaDocumento({...formBusquedaDocumento, [field] : value}))
        validateFormBusquedaDocumento(field, value)
    }

    const validateFormCliente = (field: string, value: string) => {
        let message = ''

        switch (field) {
            case 'nombre':
                if(!value || value.trim() === ''){message = 'Nombre es requerido'; break;}         
                break;
            case 'nitTercero':
                if(!REGEX_NIT.test(value) && value.trim() !== '') {message = 'Fomato de NIT incorrecto'; break}
                break;
            case 'noDocumento':
                if(!value || value.trim() === ''){message = 'NIT es requerido.'; break}
                if(!REGEX_NIT.test(value)) {message = 'Fomato de NIT incorrecto'; break}
                break;
            case 'departamento':
                    if(!value || value.trim() === ''){message = 'Departamento es requerido.'}
                    if(value && value !== '' && value !== formCliente.departamento){
                        let nombreDepartamento = departamentos.find(departamento => departamento.codigo === value)?.valor
                        
                        if(nombreDepartamento){
                            dispatch(getMunicipios(parseInt(value), nombreDepartamento, true))
                            dispatch(handleSetFormCliente({...formCliente, departamentoDescripcion: nombreDepartamento, municipio: '', departamento: value}))
                        }
                    }
                break;
            case 'municipio':
                if(!value || value.trim() === ''){message = 'Municipio es requerido.'}
                break;
            case 'direccion':
                if(!value || value.trim() === ''){message = 'Dirección es requerida.'}
                break;
            case 'email':
                const chipsEmail = formCliente.chipsEmail?.length || 0;
                if (chipsEmail <= 0 && (!value || value.trim() === '')){message = 'Correo electrónico es requerido.'; break;}
                if (value.trim() !== "" && !REGEX_EMAIL.test(value)) {message = 'Correo electrónico inválido'; break;}
                break;
            case 'telefono':
                if(!value || value.trim() === ''){message = 'Teléfono celular es requerido.'; break;}
                if(value.trim().length < 11){message = 'Teléfono celular inválido.'; break;}
                break;
            case 'actividad':
                if(!value || value.trim() === ''){message = 'Actividad económica es requerida.'; break;}
                break;
            case 'sucursal':
                if(!value || value.trim() === ''){message = 'Sucursal es requerida.'; break;}
                break;
            case 'serie':
                if(!value || value.trim() === ''){message = 'Serie es requerida.'; break;}
                break;
            case 'nrc':
                if(!value || value.trim() === ''){message = 'NRC es requerido.'; break;}
                break;
        }

        dispatch(handleErrorsFormCliente({
            ...errorsCliente,
            [field] : message
        }))

        return (message)
    }

    const validateFormBusquedaDocumento = (field: string, value: string) => {
        let message = ''
        let fechaActual = new Date()

        switch(field){
            case 'tipoDocumento':
                if(value.trim() === '') message = 'El tipo de documento es obligatorio.'
                break;
            case 'fechaInicial':
                let fecha = new Date(value)
                if(fecha > fechaActual){message = 'La fecha de búsqueda inicial no puede ser mayor a la fecha actual.'; break;}
                if(value.trim() === ''){message = 'Fecha inicial es obligatoria.'; break;}
                break;
            case 'fechaFinal':
                let fechaFinal = new Date(value)
                let fechaInicial = new Date(formBusquedaDocumento.fechaInicial)
                if(fechaFinal > fechaActual){message = 'La fecha de búsqueda final no puede ser mayor a la fecha actual.'; break;}
                if(fechaFinal < fechaInicial){message = 'La fecha de búsqueda final no puede ser menor a la fecha de búsqueda inicial.'; break;}
                if(value.trim() === ''){message = 'Fecha final es obligatoria.'; break;}
                break;
            case 'cantidad':
                if(value.trim() === '' || parseFloat(value) < 0){message = 'La cantidad debe ser mayor a 0.'; break;}
                break;
            case 'noIdentificacion':
                switch(formBusquedaDocumento.tipoIdentificacion){
                    case '36':
                        if(!REGEX_NIT.test(value) && value.trim() !== '') {message = 'Fomato de NIT incorrecto'; break}
                        break;
                    case '03':
                        const regexPasaporte = /^([a-zA-Z0-9]{5,20})$/i
                        if (!regexPasaporte.test(value) && value.trim() !== '') message = 'Formato de pasaporte incorrecto'
                        break;
                    case '13':
                        if(!REGEX_INTEGER.test(value) || value.length > 9 || value.length < 9 && value.trim() !== '') {message = 'Formato de DUI incorrecto'; break}
                        break;
                    case '02':
                        const regex = /^([0-9]{5,10})$/i
                        if(!regex.test(value) && value.trim() !== '') {message = 'Formato incorrecto de carnet de residente'; break}
                        break;
                    case '37':
                        const regexOtrosDocumentos = /^([0-9]{3,7})$/i
                        if (!regexOtrosDocumentos.test(value) && value.trim() !== '') message = 'Formato incorrecto de otros documentos'
                        break;
                }
                break;

        }
        dispatch(handleErrorsFormBusquedaDocumento({
            ...errorsFormBusquedaDocumento,
            [field] : message
        }))

        return (message)
    }

    const validateFormDocumentoFisico = (field: string, value: string) => {
        let message = ''

        switch (field){
            case 'tipoDTE':
                if(value.trim() === '')message = 'Tipo de documento es obligatorio.'
                break;
            case 'noDocumento':
                if(value.trim() === '') message = 'Número de documento es obligatorio.'
                break;
            case 'fechaEmision':
                let fecha = new Date ()
                let fechaEmi = new Date(value)

                if(fechaEmi > fecha) {message = 'La fecha de emisión no puede ser mayor a la fecha actual'; break;}
                if(value.trim() === '') {message = 'Fecha de emisión es obligatoria.'; break}
                if(fecha.getMonth() !== fechaEmi.getMonth() || fecha.getFullYear() !== fechaEmi.getFullYear()) {message = 'El documento debe ser emitido en el mes actual.'; break}
                break;
            case 'montoIVA':
                if(parseFloat(value || '0').toFixed(2) !== (parseFloat(formDocumentoFisico?.gravadas || '0') * 0.13).toFixed(2) && formDocumentoFisico.tipoDTE !== '11'){
                    message = `El monto del IVA es incorrecto. Monto esperado: $${(parseFloat(formDocumentoFisico?.gravadas || '0')*0.13).toFixed(2)}`
                }
                break;
        }
        dispatch(handleErrorsFormDocumentoFisico({
            ...errorsDocumentoFisico,
            [field] : message
        }))

        return (message)
    } 

    const validateChange = (field: string, value: string) => {
        switch(field){
            case 'nombreTercero':
            case 'nombre':
                return (REGEX_LETRAS_ESPACIOS.test(value))
            case 'descripcion':
                    return validarRegexLetras(value);
            case 'cantidad':
            case 'nitTercero':
            case 'nrc':
                    return validarRegexNumericoInt(value);
            case 'precio':
            case 'gravadas':
            case 'noSujeto':
            case 'exentas':
            case 'montoIVA':
                    return validarRegexNumericoFloat2Decimales(value);
            case 'descuento':
                    return validarRegexNumericoFloat2Decimales(value);
            default:
                return true
        }
    }

    const cargarSucursales = async() => {
        const newFormCliente = { ...formCliente, datosSucursal: [], loadedSucursal: true };

        try {
            let message = 'No se logró obtener el catalogo de sucursales'
            const response: any = await api_getSucursales({
                idsucursal: `${datos.sucursal_seleccionada}`,
                tipodocumento: '08'
            })
            
            if (response.body && !response.message) {
                const sucursal = response.body;
                const hayDocs = sucursal[0]?.Documento?.length;
                
                if (hayDocs) {
                    newFormCliente.datosSucursal = sucursal;
                }
                dispatch(handleSetFormCliente(newFormCliente));
            } else {
                dispatch(generalOpenModalError(response.message || message))
            }
        } catch (error: any) {
            if(error?.response?.data?.errorCode === 1) { dispatch(handleSetFormCliente(newFormCliente)); return; }
            dispatch(generalOpenModalError(error?.response?.data?.message ?? 'Error al obtener las sucursales', error?.response?.data?.status))
        }
    }

    const footer_onClickNext = async() => {
        switch (view) {
            case 'Formularios':
                let errors: { [key: string]: string } = {};

                Object.keys(formCliente).forEach((key) => {
                if (validateFormCliente(key, formCliente[key])){
                    let propiedad = key
                    let value = validateFormCliente(key, formCliente[key])
                    errors[propiedad] = value
                }
                })
                dispatch(handleErrorsFormCliente({
                    ...errorsCliente,
                    ...errors
                }))

                if(Object.values(errors).some((err) => err !== '')){
                    dispatch(generalOpenModalInfo('Revisa los datos del formulario de cliente.'))
                    return;
                }

                if(documentosAsociados.length === 0){
                    dispatch(generalOpenModalInfo('Debes asociar al menos un documento para continuar.'))
                    return;
                }

                const datosReceptor:any = dispatch(docsDatosReceptorSiguienteDispatch())
                if(datosReceptor === true) return;
                
                if(calculosDocumentos().test_total <= 0){
                    dispatch(generalOpenModalInfo('El total de la operación contiene un valor inválido, verifica los documentos que deseas asociar.'))
                    return
                }

                try {
                    dispatch(generalShowLoader(true))
                    await Promise.all([
                        dispatch(facturacionGetUUID('08', false))
                    ])
                } finally {
                    dispatch(generalShowLoader(false))
                }
                dispatch(handleChangeView('Previsualizacion'))
                break;
            case 'Previsualizacion':
                dispatch(handleActiveModalEmitir(true))
                break;
            case 'Detalle':
                dispatch(handleActiveModalMasOpciones(true))
                break;
        }
    }

    const footer_onClickBack = () => {
        switch (view) {
            case 'Formularios':
                if(productos.length > 0) dispatch(handleActiveModalQuitarTodo(true))
                break;
            case 'Previsualizacion':
                dispatch(handleChangeView('Formularios'))
                break;
            case 'Detalle':
                dispatch(docsAsociadosReset())
                dispatch(handleRestarFlujo())
                break;
        }
    }

    const footer_textButtons = () => {
        let textBack = ''
        let textNext = ''
        let iconBack = ''
        let iconNext = ''
        switch(view){
            case 'Formularios':
                textBack = 'Quitar todo'
                textNext = 'Siguiente'
                iconBack = ''
                iconNext = FlechaDerechaIcon
                break;
            case 'Previsualizacion':
                textBack = 'Anterior'
                textNext = 'Emitir'
                iconBack = ''
                iconNext = EmitirIcon
                break;
            case 'Detalle':
                textBack = 'Emitir nuevo'
                textNext = 'Más opciones'
                iconBack = ''
                iconNext = MasOpcionesIcon
                break;
        }

        return {
            next: {
                text: textNext,
                icon: iconNext
            },
            back: {
                text: textBack,
                icon: iconBack
            }
        }
    }

    const button_onClickQuitarTodo = () => {
        dispatch(handleAddProducto([]))
        modal_cerrarQuitarTodo()
        dispatch(handleSetDocumentosAsociados([]))
        dispatch(generalOpenModalInfo('Se eliminaron todos los productos de la lista'))
    }

    const button_agreagarDocumentoFisico = () => {
        dispatch(handleActiveModalAgregarDocumentoFisico(true))
    }

    const modal_button_descargarJson = () => dispatch(descargarJson({idFactura: response_Emitir?.codigoGeneracion, json: response_Emitir?.JsonFacturaFile}))   


    const actionButton_desasociar = (numeroControl: string) => {
        let asociadosArray = documentosAsociados.filter((doc: any) => doc.numeroControl !== numeroControl)
        
        let productosArray = productos.filter((producto: any) => producto.documentoAsociado !== numeroControl)

        dispatch(handleSetDocumentosAsociados(asociadosArray))
        dispatch(handleAddProducto(productosArray))

    }

    const actionButton_editarDocumentoFisico = (documento: any) => {
        dispatch(handleSetFormDocumentoFisico({
            ...formDocumentoFisico,
            tipoDTE: documento.tipoDocumento,
            noDocumento: documento.numeroControl,
            fechaEmision: documento.fechaEmision?.split(' ')[0],
            gravadas: documento.resumen.gravadas,
            noSujeto: documento.resumen.noSujeto,
            exentas: documento.resumen.exentas,
            montoIVA: documento.resumen.montoIVA
        }))
        dispatch(handleActiveModalEditarDocumentoFisico(true))
        dispatch(handleSetDocumentoFisicoEdit(documento.numeroControl))
    }

    const actionButton_asociar = (documento: any) => {
        
        let arrayProductos = productos
        let documentoObject = {
            tipoGeneracion: 2,
            data: documento,
            resumen: documento?.DetallesDTE?.resumen,
            numeroControl: documento?.DetallesDTE?.identificacion?.numeroControl,
            codigoGeneracion: documento?.codigoGeneracion,
            tipoDocumento: documento?.DetallesDTE?.identificacion?.tipoDte,
            fechaEmision: `${documento?.DetallesDTE?.identificacion?.fecEmi} ${documento?.DetallesDTE?.identificacion?.horEmi}`,
            productos: documento?.DetallesDTE?.cuerpoDocumento?.map((producto: any, index: any) => {

                let productoObject = {
                    servicio : producto.tipoItem === 0,
                    descripcion: producto.descripcion,
                    cantidad: `${producto.cantidad}`,
                    precio: `${producto.precioUni}`,
                    tipoDescuento: "Monto",
                    descuento: `${producto.montoDescu}`,
                    exento: producto.noGravado === 1,
                    conIva: false,
                    documentoAsociado: documento?.CorrelativoSuscripcion, 
                    indexAsociado: index, 
                    codigoGeneracion: documento?.codigogeneracion
                } 

                arrayProductos.push(productoObject)
                return (productoObject)
            })
        }
        let tempArray = [...documentosAsociados]
        tempArray.push(documentoObject)
        
        dispatch(handleSetDocumentosAsociados(tempArray))
        dispatch(handleAddProducto(arrayProductos))

    }

    const modal_button_agregarDocumentoFisico = (documento: any) => {
        let errors: { [key: string]: string } = {};

        for (const field in formDocumentoFisico){
            console.log(field, formDocumentoFisico[field]);
            
            if(validateFormDocumentoFisico(field, formDocumentoFisico[field])){
                errors[field] = validateFormDocumentoFisico(field, formDocumentoFisico[field])
            }
        }

        
        if(Object.values(errors).some((err) => err !== '')) {
            dispatch(handleErrorsFormDocumentoFisico({
                ...errorsDocumentoFisico,
                ...errors
            })) 
            
            return
        }
        
        let arrayProductos = productos
        let documentoObject = {
            tipoGeneracion: 1,
            data: documento,
            resumen: {
                gravadas: formDocumentoFisico.gravadas,
                noSujeto: formDocumentoFisico.noSujeto,
                exentas: formDocumentoFisico.exentas,
                exportaciones: formDocumentoFisico.tipoDTE === '11' ? formDocumentoFisico.gravadas : '0',
                montoIVA: formDocumentoFisico.montoIVA
            },
            numeroControl: formDocumentoFisico.noDocumento,
            codigoGeneracion: '',
            tipoDocumento: formDocumentoFisico.tipoDTE,
            fechaEmision: `${formDocumentoFisico.fechaEmision}  `,
            productos: []
        }

        let tempArray = [...documentosAsociados]
        
        if(modal_editarDocumentoFisico){
            let indexDocumento = documentosAsociados.findIndex((doc) => doc.numeroControl === documentoFisicoEdit)
            tempArray[indexDocumento] = documentoObject
        } else {
            tempArray.push(documentoObject)
        }
        
        dispatch(handleSetDocumentosAsociados(tempArray))
        dispatch(handleAddProducto(arrayProductos))
        modal_cerrarDocumentoFisico()
    }

    const actionButton_eliminarProducto = (index: any) => {
        dispatch(handleSetIndexProductoEdit(index))
        dispatch(handleActiveModalEliminar(true))
    }
    
    const modal_button_onConfirmEliminar = () => {
        let tempArray = productos
        tempArray.splice(productoIndex, 1)
        dispatch(handleAddProducto(tempArray))
        dispatch(generalOpenModalInfo('Producto eliminado exitosamente.'))
        modal_cerrarModalEliminar()
    }
    
    const modal_cerrarModalEliminar = () => {
        dispatch(handleSetIndexProductoEdit(null))
        dispatch(handleActiveModalEliminar(false))
    }

    const modal_cerrarQuitarTodo = () => {
        dispatch(handleActiveModalQuitarTodo(false))
    }

    const modal_cerrarDocumentoFisico = () => {
        dispatch(handleActiveModalAgregarDocumentoFisico(false))
        dispatch(handleActiveModalEditarDocumentoFisico(false))
        dispatch(handleSetFormDocumentoFisico({
            tipoDTE: '',
            noDocumento: '',
            fechaEmision: '',
            gravadas: '0',
            noSujeto: '0',
            exentas: '0',
            montoIVA: '0'
        }))
        dispatch(handleErrorsFormDocumentoFisico({
            tipoDTE: '',
            noDocumento: '',
            fechaEmision: '',
            gravadas: '',
            noSujeto: '',
            exentas: '',
            montoIVA: ''
        }))
    }

    const modal_cerrarEmitir = () => {
        dispatch(handleActiveModalEmitir(false))
    }

    const modal_button_emitirNuevo = async() => {
        dispatch(docsAsociadosReset());
        dispatch(handleAddProducto([]))
        await dispatch(handleRestarFlujo())
        await dispatch(handleSetFormCliente(
            {
                fecha: '',
                tipoDocumento: '',
                noDocumento: '',
                nombre: '',
                departamento: '',
                municipio: '',
                direccion: '',
                email: '',
                chipsEmail: [],
                telefono: '',
                actividad: '',
                actividadDescripcion: '',
                departamentoDescripcion: '',
                municipioDescripcion: '',
                nrc: '',
                
                datosSucursal: [],
                datosDocumento: [],
        
                sucursal: '',
                serie: '',
            }
        ))
        await dispatch(handleAddProducto([]))
        setTimeout(() => {
            dispatch(handleChangeView('Formularios'))
        }, 2)
        dispatch(handleAddProducto([]))
    }

    const obtenerFechas = () => {
        // Obtén la fecha de hoy
        let fechaHoy = new Date();
      
        // Resta 3 meses a la fecha de hoy
        let añoHaceTresMeses = fechaHoy.getFullYear();
        let mesHaceTresMeses = fechaHoy.getMonth() - 3;
      
        // Ajusta el año y el mes si es necesario
        if (mesHaceTresMeses < 0) {
          añoHaceTresMeses -= 1;
          mesHaceTresMeses += 12;
        }
      
        // Obtiene el último día del mes hace 3 meses
        const últimoDíaHaceTresMeses = new Date(añoHaceTresMeses, mesHaceTresMeses + 1, 0).getDate();
      
        // Formatea la fecha hace 3 meses en el formato 'yyyy-MM-dd'
        const fechaFormateadaHaceTresMeses = `${añoHaceTresMeses}-${(mesHaceTresMeses + 1).toString().padStart(2, '0')}-${últimoDíaHaceTresMeses.toString().padStart(2, '0')}`;
      
        // Obtiene el año, mes y día de la fecha actual en formato 'yyyy-MM-dd'
        const añoActual = fechaHoy.getFullYear();
        const mesActual = fechaHoy.getMonth() + 1;
        const díaActual = fechaHoy.getDate();
      
        const fechaFormateadaActual = `${añoActual}-${mesActual.toString().padStart(2, '0')}-${díaActual.toString().padStart(2, '0')}`;
      
        return {
          fechaHaceTresMeses: fechaFormateadaHaceTresMeses,
          fechaActual: fechaFormateadaActual,
        };
    }

    const buttonActiveModalBusquedaDocumentos = (active: boolean) => {
        if(active){
            if(!formCliente.noDocumento || formCliente.noDocumento.trim() === ''){
                dispatch(generalOpenToastInfo('Completa la información del receptor'))
                return
            }
        } 
        dispatch(handleActiveModalBusquedaDocumentos(active))
    }

    const buscarDocumentosAsociados = async() => {
        let errors: { [key: string]: string } = {};

        Object.keys(formBusquedaDocumento).forEach((key) => {
            if (validateFormBusquedaDocumento(key, formBusquedaDocumento[key])){
                let propiedad = key
                let value = validateFormBusquedaDocumento(key, formBusquedaDocumento[key])
                errors[propiedad] = value
            }
        })
        dispatch(handleErrorsFormBusquedaDocumento({
            ...errorsFormBusquedaDocumento,
            ...errors
        }))

        if(Object.values(errors).some((err) => err !== '')){
            dispatch(generalOpenToastInfo('Ingresa los datos de búsqueda correctamente.'))
            return;
        }
            
            dispatch(handleSetDocumentosEncontrados([]))
            dispatch(handleActiveLoaderDocumentosAsociados(true))
            try {

                let body = {
                    fechaDesde: `${formBusquedaDocumento.fechaInicial} 00:00:00` || '-1',
                    fechaHasta: `${formBusquedaDocumento.fechaFinal} 23:59:59` || '-1',
                    // tipoDoc: '36',
                    nitEmision: datosEmisor.nit, 
                    // nrc_receptor: "-1",
                    // nrc_emisor: datosEmisor.nrc,
                    nitVentaTercero: null,
                    tipodte: formBusquedaDocumento.tipoDocumento || '-1',
                    // NombreCompleto: formBusquedaDocumento.nombre || '-1',
                    tokenGateway: localStorage.getItem(KEYS.TOKEN),
                  }

                  const response: any = await api_buscarDocumentosAsociados(body)
                  console.log(response?.body?.body && Array.isArray(response?.body?.body) && response?.body?.body.length > 0);
                  
                  if(response?.body?.body && Array.isArray(response?.body?.body) && response?.body?.body.length > 0){
                    let documentos: Array<any> = []
                    response?.body?.body?.forEach((doc: any) => {{
                        if(doc.documento.ventaTercero){
                            documentos.push({
                                DetallesDTE: doc.documento,
                                ...doc
                            })
                        }
                    }})
                    if(documentos.length > 0){
                        dispatch(handleSetDocumentosEncontrados(documentos))
                        dispatch(generalOpenToastInfo('Documentos asociados al cliente disponibles.'))
                    } else {
                        dispatch(handleSetDocumentosEncontrados([]))
                        dispatch(generalOpenToastInfo('No se encontraron documentos por asociar al cliente.'))
                    }
                } else {
                    dispatch(handleSetDocumentosEncontrados([]))
                    dispatch(generalOpenToastInfo('No se encontraron documentos por asociar al cliente.'))
                }
                
            } catch (error) {
                console.log(error);
                
                dispatch(handleSetDocumentosEncontrados([]))
                dispatch(generalOpenToastInfo('No se encontraron documentos por asociados al cliente.'))
            } finally {
                dispatch(handleActiveLoaderDocumentosAsociados(false))
            }
    }

    const modal_button_limpiarFormBusquedaDocumento = () => {
        dispatch(handleSetFormBusquedaDocumento({
            ...formBusquedaDocumento,
            fechaInicial: '',
            fechaFinal: '',
            tipoDocumento: ''
        }))

        dispatch(handleErrorsFormBusquedaDocumento({
            nombre: '',
            tipoIdentificacion: '',
            noIdentificacion: '',
            fechaInicial: '',
            fechaFinal: '',
            tipoDocumento: ''
        }))
    }

    const buscarCliente = async() => {
        if(formCliente.noDocumento && (validateFormCliente('noDocumento', formCliente.noDocumento) === '')){
            // dispatch(generalShowLoader(true))
            try {
                let body = {
                    opcion: '1',
                    tipoDocumento: '36',
                    numDocumento: formCliente.noDocumento
                }

                const user: any = await api_buscarCliente(body)

                if(user?.body !== null){
                    if (user?.body?.notificarcorreo?.length > 0) { dispatch(generalOpenModalInfo(getEmailNotifyMsg(user.body.notificarcorreo))); }
                    dispatch(handleSetInfoClienteEncontrado(user.body))
                    dispatch(handleActiveModalClienteEncontrado(true))
                } else {
                    dispatch(generalOpenToastInfo('Cliente nuevo, se registrará al finalizar la factura.', 'Aviso'))
                    dispatch(handleSetInfoClienteEncontrado(null))
                    dispatch(handleSetFormCliente({
                        ...formCliente,
                        direccion: '',
                        email: '',
                        telefono: '',
                        nrc: '',
                        actividad: '',
                        departamento: '',
                        municipio: ''
                    }))
                }

            } catch (err: any) {
                dispatch(generalOpenToastError(err?.response?.data?.message || 'Se produjo un error al buscar la información del cliente.', "Alerta"))
            } finally {
                dispatch(generalShowLoader(false))
            }
        }
    }

    const modal_button_verDetalle = () => {
        dispatch(handleChangeView('Detalle'))
        dispatch(handleActiveModalEmitido(false))
        modal_cerrarEmitir()
    }

    const modal_cerrarMasOpciones = () => {
        dispatch(handleActiveModalMasOpciones(false))
    }

    const modal_button_cerrarModalEmitido = () => {
        dispatch(handleActiveModalEmitido(false))
        dispatch(docsAsociadosReset());
    }

    const modal_button_enviarCorreo = () => {
        dispatch(handleActiveModalCorreo(true))
    }

    const modal_button_cerrarEnviarCorreo = () => {
        dispatch(handleActiveModalCorreo(false))
    }

    const modal_button_descargarExcel = async() => {
        try {
            dispatch(generalShowLoader(true))
            await dispatch(getExcelFactura(
                {
                    Documento: response_Emitir.JsonFactura,
                    Sello: response_Emitir.Sello,
                },
                response_Emitir.codigoGeneracion
            ))
        } catch (error) {
            dispatch(generalOpenModalError('Ocurrió un error al descargar el Excel.'))
        } finally {
            dispatch(generalShowLoader(false))
        }
    }

    const modal_button_descargarImagen = async() => {
        try {
            dispatch(generalShowLoader(true))
            await dispatch(getFacturaImage(
                {
                    Documento: response_Emitir.JsonFactura,
                    Sello: response_Emitir.Sello,
                    MostrarPrecio: mostrarDetalle? '1' : '0'
                },
                response_Emitir.codigoGeneracion
            ))
        } catch (error) {
            dispatch(generalOpenModalError('Ocurrió un error al descargar la imagen.'))
        } finally {
            dispatch(generalShowLoader(false))
        }
    }

    const modal_button_descargarPDF = async() => {
        try {
            dispatch(generalShowLoader(true))
            await dispatch(getFacturaPDF_New(
                {
                    Documento: response_Emitir.JsonFactura,
                    Sello: response_Emitir.Sello,
                    MostrarPrecio: mostrarDetalle? '1' : '0'
                },
                response_Emitir.serie,
                response_Emitir.estadoanulacion
            ))
        } catch (error) {
            dispatch(generalOpenModalError('Ocurrió un error al descargar el PDF.'))
        } finally {
            dispatch(generalShowLoader(false))
        }
    }

    const modal_button_imprimir = () => {
        dispatch(handleActiveModalImprimir(true))
    }

    const modal_cerrarImprimir = () => {
        dispatch(handleActiveModalImprimir(false))
    }

    const modal_button_imprimirTicket = () => {
        dispatch(handleActiveModalImprimir(true))
    }

    const modal_button_descargarPDFTicket = async () => {
        try {
            dispatch(generalShowLoader(true))
            await dispatch(getFacturaPDF_New(
                { Documento: response_Emitir.JsonFactura, Sello: response_Emitir.Sello, ModoTicket: true },
                response_Emitir.serie, response_Emitir.estadoanulacion
            ))
        } catch (error) {
            dispatch(generalOpenModalError('Ocurrió un error al descargar el Ticket PDF.'))
        } finally {
            dispatch(generalShowLoader(false))
        }
    }

    const modal_button_onClickEnviarCorreo = async(email: string) => {
        try {
            dispatch(generalShowLoader(true))
            const sendEmail: OPSendEmail = {
                Correo: email,
                Documento: response_Emitir.JsonFactura,
                Sello: response_Emitir.Sello,
                idSucursal: datos?.sucursal_seleccionada,
                idEmpresa: `${datos?.codigo_empresa}`
            }
            const res:any = await dispatch(sendTransactionEmail(sendEmail))
            if(res){
                dispatch(generalOpenModalMessage('Enviar por correo electrónico', 'El correo electrónico fue enviado exitosamente.'))
                return true;
            }
        } catch (error: any) {
            dispatch(generalOpenModalError(error?.response?.data?.message || 'Ocurrió un error al enviar el correo'))
            return false
        } finally {
            dispatch(generalShowLoader(false))
        }
    }

    const modal_button_anular = () => {
        dispatch(handleActiveModalAnular(true))
    }

    const modal_cerrarAnular = () => {
        dispatch(handleActiveModalAnular(false))
    }

    const modal_cerrarClienteEncontrado = () => {
        dispatch(handleActiveModalClienteEncontrado(false))
    }

    const modal_button_aceptarClienteEncontrado = async() => {
        let tempForm: { [key: string]: any } = {
            ...formCliente,
            nombre: clienteEncontrado.nombre,
            tipoDocumento: clienteEncontrado.tipoDocumento,
            noDocumento: clienteEncontrado.numDocumento,
            direccion: clienteEncontrado.direccion,
            email: '',
            chipsEmail: clienteEncontrado.email.split(','),
            telefono: clienteEncontrado.telefono,
            nrc: clienteEncontrado.nrc,
            actividad: clienteEncontrado.codActividad,
            departamento: clienteEncontrado.departamento,
            municipio: clienteEncontrado.municipio
        }

        let errors: { [key: string]: string } = {};

        Object.keys(tempForm).forEach((key) => {
            if (validateFormCliente(key, tempForm[key]) && key !== "email"){
                let propiedad = key
                let value = validateFormCliente(key, tempForm[key])
                errors[propiedad] = value
            }
        })
        dispatch(handleErrorsFormCliente({
            ...errors
        }))     
        dispatch(handleSetFormCliente(tempForm))
        modal_cerrarClienteEncontrado()        
    }

    const modal_button_onConfirmAnular = async() => {
        dispatch(generalShowLoader(true))

        try {
            //------------------------
            let documento = formCliente?.datosSucursal?.find((sucursal: any) => sucursal?.idsucursal === formCliente?.sucursal)?.Documento?.find((doc: any) => doc?.idsucursaldocumento === formCliente?.serie)
            let serie = `${documento?.serie}-${documento?.numeroactual}`
            let ivaTotal = 0
            productos.forEach((producto) => {
                let precioUnitario = producto.conIva ? parseFloat(producto.precio)/1.13 : parseFloat(producto.precio)
                let ivaProducto = (precioUnitario * 0.13) * parseFloat(producto.cantidad)
                if(!producto.exento){
                    ivaTotal += ivaProducto
                }
            })
            //------------------------
            
            const anularDoc = {
              documento: response_Emitir.JsonFactura,
              sellorecibido: response_Emitir.Sello,
              DetallesDTE: {
                receptor: {
                  numDocumento: formCliente.noDocumento,
                  tipoDocumento: formCliente.tipoDocumento,
                  nrc: formCliente.nrc,
                  nombre: formCliente.nombre?.trim(),
                  telefono: formCliente.telefono?.trim(),
                  correo: unirChipsReturnFirst(formCliente.chipsEmail, formCliente.email),
                },
                emisor: {
                  nombre: datosEmisor.nombre,
                  nit: datosEmisor.nit,
                  nrc: datosEmisor.nrc,
                  telefono: datosEmisor.telefono,
                  correo: datosEmisor.correo,
                  tipoEstablecimiento: datosEmisor.tipoestablecimiento,
                },
                resumen: {
                  totalIva: isNaN(ivaTotal) ? '0' : `${ivaTotal.toFixed(2)}`,
                },
                identificacion: {
                  tipoDte: '08',
                  codigoGeneracion: response_Emitir.codigoGeneracion,
                  numeroControl: `DTE-08-${serie}`,
                  fecEmi: convertDateFormatAnular(response_Emitir.fhProcesamiento.split(' ')[0]),
                  IDsucursalDoc: documento.idsucursaldocumento
                },
              },
            }
            const response: any = await dispatch(anularFactura_DTE(anularDoc))
            if(response){
                dispatch(generalOpenModalInfo('Documento anulado exitosamente'))
                modal_button_emitirNuevo()
            }
            

        } catch (error: any) {
            dispatch(generalOpenModalError(error?.response?.data?.body?.descripcionMsg || 'Ocurrió un error al anular el documento.'))
        } finally {
            dispatch(generalShowLoader(false))
        }
    }

    const modal_button_closeWarningAsociarDocumentos = () => {
        dispatch(handleActiveModalAdvertenciaAsociarDocumentos(false))
    }

    const guardarCliente = async() => {
        try {
            let body = {
                opcion: 2,
                tipoDocumento: formCliente.tipoDocumento,
                numDocumento:  formCliente.noDocumento,
                nombre:  formCliente.nombre,
                direccion: formCliente.direccion,
                email: unirChipsJoin(formCliente.chipsEmail, formCliente.email),
                telefono:  formCliente.telefono,
                nrc:  formCliente.nrc,
                codActividad:  formCliente.actividad,
                descActividad:  actividadesEconomicas.find((actividad) => actividad.codigo === formCliente.actividad)?.valor,
                departamento: formCliente.departamento,
                municipio: formCliente.municipio,
              }
            const response: any = await api_buscarCliente(body)
            if (response){
                dispatch(generalOpenToastSuccess(response?.message || "Los datos del cliente han sido guardados satisfactoriamente."))
            }
        } catch (error: any) {
            dispatch(generalOpenToastError(error?.response?.data?.message || 'Se produjo un error al guardar la información del cliente.', "Alerta"))
        }
    }

    const button_mostrarDetalle = (active: boolean) => {
        dispatch(handleActiveMostrarDetalle(active))
    }

    const calculosDocumentos = () => {
        let test_totalOperacionesNoSujetas = 0
        let test_totalOperacionesExentas = 0
        let test_totalOperacionesGravadas = 0
        let test_totalOperacionesExportacion = 0
        let test_montoTotalOperacion = 0
        let test_iva = 0
        let test_ivaPercibido = 0
        let test_total = 0

        documentosAsociados.forEach((doc) => {
            if(doc.tipoGeneracion === 1){
                switch(doc.tipoDocumento){
                    case '05':
                        test_totalOperacionesNoSujetas -= parseFloat(doc.resumen.noSujeto || '0')
                        test_totalOperacionesExentas -= parseFloat(doc.resumen.exentas || '0')
                        test_totalOperacionesGravadas -= parseFloat(doc.resumen.gravadas || '0')
                        test_iva -= parseFloat(doc.resumen.montoIVA || '0')
                        break;
                    case '11':
                        test_totalOperacionesExportacion += parseFloat(doc.resumen.exportaciones || '0')
                        break;
                    default:
                        test_totalOperacionesNoSujetas += parseFloat(doc.resumen.noSujeto || '0')
                        test_totalOperacionesExentas += parseFloat(doc.resumen.exentas || '0')
                        test_totalOperacionesGravadas += parseFloat(doc.resumen.gravadas || '0')
                        test_iva += parseFloat(doc.resumen.montoIVA || '0')
                        break;
                }
            }
        })

        test_montoTotalOperacion = test_totalOperacionesNoSujetas + test_totalOperacionesExentas + test_totalOperacionesGravadas + test_totalOperacionesExportacion
        test_total = test_montoTotalOperacion + test_iva


        let totalExportacion = 0
        let sumaOperaciones = 0 
        let iva = 0
        let subtotal = 0
        let ivaPercibido = 0
        let ivaRetenido = 0
        let retencionRenta = 0
        let total = 0

        documentosAsociados.forEach((doc) => {
            // sumaOperaciones += doc?.resumen?.totalGravada
            ivaPercibido += doc?.resumen?.ivaPerci1 || 0
            ivaRetenido += doc?.resumen?.ivaRete1 || 0
            retencionRenta += doc?.resumen?.reteRenta || 0

            if(doc.tipoGeneracion === 2){
                switch(doc?.tipoDocumento){
                    case '01':
                        console.log(parseFloat(doc?.resumen?.totalGravada)/1.13);
                        
                        sumaOperaciones += (parseFloat(doc?.resumen?.totalGravada)/1.13)
                        iva += (parseFloat(doc?.resumen?.totalGravada)/1.13) * 0.13
                        break;
                    default:
                        sumaOperaciones += parseFloat(doc?.resumen?.totalGravada || '0')
                        iva += parseFloat(doc?.resumen?.tributos?.find((imp: any) => imp.codigo === '20')?.valor || '0')
                        break;
                }
            } else {
                sumaOperaciones += parseFloat(doc?.resumen?.gravadas || '0') + parseFloat(doc?.resumen?.exentas || '0') + parseFloat(doc?.resumen?.noSujeto || '0')
                iva += parseFloat(doc?.resumen?.montoIVA)
            }
        })

        iva = iva - ivaRetenido
        subtotal = sumaOperaciones + iva
        total = subtotal + ivaPercibido - ivaRetenido - retencionRenta

        return  {
            sumaOperaciones: sumaOperaciones,
            iva: iva,
            subtotal: subtotal,
            ivaPercibido: ivaPercibido,
            ivaRetenido: ivaRetenido,
            retencionRenta: retencionRenta,
            total: total,

            totalExportacion: totalExportacion,
            test_totalOperacionesNoSujetas : test_totalOperacionesNoSujetas,
            test_totalOperacionesExentas : test_totalOperacionesExentas,
            test_totalOperacionesGravadas : test_totalOperacionesGravadas,
            test_totalOperacionesExportacion : test_totalOperacionesExportacion,
            test_iva : test_iva,
            test_montoTotalOperacion : test_montoTotalOperacion,
            test_total: test_total,
            test_ivaPercibido : test_ivaPercibido
        }
    }

    const modal_button_emitirDocumento = async() => {
        dispatch(generalShowLoader(true))
        try{
            guardarCliente()
            // -----------------------------------------------------------------
            let descuentoTotal = 0
            let sumaOperaciones = 0
            let iva = 0
            let subtotal = 0
            let ivaPercibido = 0
            let ivaRetenido = 0
            let retencionRenta = 0
            let total = 0
            productos.forEach((producto) => {
                let precioUnitario = producto.conIva ? parseFloat(producto.precio)/1.13 : parseFloat(producto.precio)
                let descuento = isNaN(parseFloat(producto.descuento)) ? 0 : producto.tipoDescuento === 'Porcentaje' ? (precioUnitario * (parseFloat(producto.descuento)/100)) * parseFloat(producto.cantidad) : parseFloat(producto.descuento)
                let ivaProducto = ((precioUnitario * parseFloat(producto.cantidad)) - descuento) * 0.13

                sumaOperaciones += ((precioUnitario * parseFloat(producto.cantidad)) - descuento)

                if(!producto.exento){
                    iva += ivaProducto
                    subtotal += ((precioUnitario * parseFloat(producto.cantidad)) - descuento) + ivaProducto
                } else {
                    subtotal += ((precioUnitario * parseFloat(producto.cantidad)) - descuento)
                }
                descuentoTotal += descuento
            })


            total = subtotal
            let documento = formCliente?.datosSucursal?.find((sucursal: any) => sucursal?.idsucursal === formCliente?.sucursal)?.Documento?.find((doc: any) => doc?.idsucursaldocumento === formCliente?.serie)
            let serie = `${documento?.serie}-${documento?.numeroactual}`

            let impuTotal = iva
            let body: any = {
                id_user: localStorage.getItem(KEYS.ID_CLIENT),
                tipoContribuyente_receptor: formCliente.granContribuyente,
                facturas:
                [{
                    receptorManual: datosReceptor.nombre,
                    docManual: datosReceptor.numId,
                    esReceptorManual : datosReceptor.esReceptorManual,
                    tipoDocManual : datosReceptor.nombreTipoDocumento,
                    idsucursaldocumento: formCliente.serie,
                    receptorEmailsEnvio: unirChipsJoin(formCliente.chipsEmail, formCliente.email),
                    tipoDte:"08",
                    cveDoc: serie,
                    uuid: datosUUID?.CodigoGeneracion,
                    fechaDoc: `${getFechaFormato1()} ${new Date().toLocaleTimeString([], {hour: '2-digit', minute: '2-digit', second: '2-digit'})}`,
                    canTotalExenta : calculosDocumentos().test_totalOperacionesExentas > 0 ? calculosDocumentos().test_totalOperacionesExentas?.toFixed(2) : '0',
                    canTotalExportacion: calculosDocumentos().test_totalOperacionesExportacion > 0 ? calculosDocumentos().test_totalOperacionesExportacion?.toFixed(2) : '0',
                    canTotalnoSujetas: calculosDocumentos().test_totalOperacionesNoSujetas > 0 ? calculosDocumentos().test_totalOperacionesNoSujetas?.toFixed(2) : '0',
                    canTotalGravada: calculosDocumentos().test_totalOperacionesGravadas > 0 ? calculosDocumentos().test_totalOperacionesGravadas?.toFixed(2) : '0',
                    impuTotal: calculosDocumentos().test_iva > 0 ? calculosDocumentos().test_iva?.toFixed(2) : '0',
                    ivaPerci: calculosDocumentos().test_ivaPercibido > 0 ? calculosDocumentos().test_ivaPercibido?.toFixed(2) : '0',
                    cuerpoDocumento: documentosAsociados.map((documento) => {

                        let test_totalOperacionesNoSujetas = 0
                        let test_totalOperacionesExentas = 0
                        let test_totalOperacionesGravadas = 0
                        let test_totalOperacionesExportacion = 0
                        let test_iva = 0

                            if(documento.tipoGeneracion === 1){
                                switch(documento.tipoDocumento){
                                    case '05':
                                        test_totalOperacionesNoSujetas -= parseFloat(documento.resumen.noSujeto || '0')
                                        test_totalOperacionesExentas -= parseFloat(documento.resumen.exentas || '0')
                                        test_totalOperacionesGravadas -= parseFloat(documento.resumen.gravadas || '0')
                                        test_iva -= parseFloat(documento.resumen.montoIVA || '0')
                                        break;
                                    case '11':
                                        test_totalOperacionesExportacion += parseFloat(documento.resumen.exportaciones || '0')
                                        break;
                                    default:
                                        test_totalOperacionesNoSujetas += parseFloat(documento.resumen.noSujeto || '0')
                                        test_totalOperacionesExentas += parseFloat(documento.resumen.exentas || '0')
                                        test_totalOperacionesGravadas += parseFloat(documento.resumen.gravadas || '0')
                                        test_iva += parseFloat(documento.resumen.montoIVA || '0')
                                        break;
                                }
                            }


                        return ({
                            TipoDte: documento?.tipoDocumento,
                            TipoDteDescripcion: tipoDocumentosEmision.find((doc: any) => doc.codigodocumento === documento?.tipoDocumento)?.nombre,
                            tipoGeneracion: documento?.tipoGeneracion,
                            numeroDocumento: documento?.tipoGeneracion === 1 ? documento?.numeroControl : documento?.codigoGeneracion,
                            fechaGeneracion: documento?.fechaEmision?.split(' ')[0],
                            ventaGravada: test_totalOperacionesGravadas.toFixed(2),
                            ventaNoSuj: test_totalOperacionesNoSujetas.toFixed(2) || '0',
                            ventaExenta: test_totalOperacionesExentas.toFixed(2) || '0',
                            exportaciones: test_totalOperacionesExportacion.toFixed(2) || '0',
                            obsItem:'   ',
                            ivaItem: test_iva.toFixed(2) || '0',
                        })
                    }),
                    receptor: {
                        nombre: formCliente.nombre,
                        direccion: formCliente.direccion,
                        email: unirChipsReturnFirst(formCliente.chipsEmail, formCliente.email),
                        telefono: formCliente.telefono,
                        nit: formCliente.noDocumento,
                        nrc: formCliente.nrc,
                        codActividad: formCliente.actividad,
                        descAtvividad: actividadesEconomicas.find((actividad) => actividad.codigo === formCliente.actividad)?.valor,
                        departamento: formCliente.departamento,
                        municipio: formCliente.municipio,
                    },
                  }],
                    tokenGateway: localStorage.getItem(KEYS.TOKEN) ?? '',
                    tokenHacienda: localStorage.getItem(KEYS.HACIENDA) ?? ''
                }

                const response: any = await api_RecepcionDTE(body)
                if(response.body.estado === 'PROCESADO'){
                    if(response?.body?.NuevoToken){
                        localStorage.setItem(KEYS.HACIENDA, response?.body?.TokenHacienda)
                      }
                    dispatch(handleSetResponseEmitir(response.body))
                    dispatch(handleActiveModalEmitido(true))
                    dispatch(handleActiveModalEmitir(false))
                    dispatch(handleChangeView('Detalle'))
                  const qrResponse = await getQR(response.body.JsonFactura)
                  if(qrResponse.qr){
                      let qrString = generateQRImageFromBits(qrResponse.qr?.replace("data:image/jpeg;base64,", ""))
                      dispatch(handleSetQRCode(qrString))
                  } else {
                      dispatch(generalOpenModalError(qrResponse.message || 'Ocurrió un error al obtener el código QR'))
                  }
                }

        } catch (err: any) {
            console.log(err);
            
            let message = 'Ocurrió un error al emitir el crédito fiscal, contacta al administrador.'

            if(err.response.data.message) message = err.response.data.message
            else {
                try{
                    let messageDesc = err?.response?.data?.body?.descripcionMsg?.replace(/\[(\w+)\.(\w+)\]\s(\w+)/, '$2 de $1 : $3').toUpperCase()
                    message = messageDesc || message
                } catch {
                    message = 'Ocurrió un error al emitir el crédito fiscal, contacta al administrador.'
                }
            }

            dispatch(generalOpenModalError(message))
        } finally {
            dispatch(generalShowLoader(false))
        }
    }

    const setTableProductos = (table: any) => {
        dispatch(handleSetTableProductos(table))
    }

    useEffect(() => {
        if(formCliente.tipoDocumento && formCliente.tipoDocumento !== '') validateFormCliente('noDocumento', formCliente.noDocumento)
    }, [formCliente.tipoDocumento])

    useEffect(() => {
        validateFormDocumentoFisico('montoIVA', formDocumentoFisico?.montoIVA)
    }, [formDocumentoFisico?.gravadas])

    useEffect(() => {
        if(Array.isArray(formCliente.datosSucursal) && formCliente.datosSucursal.length > 0) cargarDatosIniciales()
    }, [formCliente.datosSucursal])

    useEffect(() => {
        dispatch(handleSetFormBusquedaDocumento({
            ...formBusquedaDocumento,
            nombre: formCliente.nombre,
            noIdentificacion: formCliente.noDocumento
        }))
    }, [formCliente])

    return {
        cargarSucursales,
        cargarDatosIniciales,
        buscarCliente,
        buscarDocumentosAsociados,

        onChangeFormCliente,
        onChangeFormBusquedaDocumento,
        onChangeFormDocumentoFisico,

        validateFormCliente,

        button_onClickQuitarTodo,
        button_agreagarDocumentoFisico,

        footer_onClickBack,
        footer_onClickNext,
        footer_textButtons,
        
        actionButton_asociar,
        actionButton_desasociar,
        actionButton_editarDocumentoFisico,

        modal_cerrarQuitarTodo,
        modal_cerrarModalEliminar,
        modal_cerrarDocumentoFisico,
        modal_cerrarEmitir,
        modal_cerrarMasOpciones,
        modal_cerrarImprimir,
        modal_cerrarAnular,
        modal_cerrarClienteEncontrado,

        modal_button_onConfirmEliminar,
        modal_button_emitirDocumento,
        modal_button_emitirNuevo,
        modal_button_verDetalle,
        modal_button_cerrarModalEmitido,    
        modal_button_enviarCorreo,
        modal_button_cerrarEnviarCorreo,
        modal_button_onClickEnviarCorreo,
        modal_button_descargarExcel,
        modal_button_descargarImagen,
        modal_button_descargarPDF,
        modal_button_imprimir,
        modal_button_imprimirTicket,
        modal_button_descargarPDFTicket,
        modal_button_anular,
        modal_button_onConfirmAnular,
        modal_button_aceptarClienteEncontrado,
        modal_button_limpiarFormBusquedaDocumento,
        modal_button_descargarJson,
        modal_button_agregarDocumentoFisico,

        modal_button_closeWarningAsociarDocumentos,
        buttonActiveModalBusquedaDocumentos,
        button_mostrarDetalle,
        setTableProductos,

        calculosDocumentos
    }
}

const handleSetFormDocumentoFisico = (form: any):ActionCL => ({type:  COMPROBANTE_LIQUIDACION_TYPES.CL_SET_FORM_DOCUMENTO_FISICO, payload: form})
const handleSetFormCliente = (form: any):ActionCL => ({type:  COMPROBANTE_LIQUIDACION_TYPES.CL_SET_FORM_CLIENTE, payload: form})
const handleSetFormProducto = (form: any):ActionCL => ({type: COMPROBANTE_LIQUIDACION_TYPES.CL_SET_FORM_PRODUCTO, payload: form})
const handleSetFormBusquedaDocumento = (form: any):ActionCL => ({type: COMPROBANTE_LIQUIDACION_TYPES.CL_SET_FORM_BUSQUEDA_DOCUMENTO, payload: form})
const handleSetDocumentoFisicoEdit = (numeroControl: any):ActionCL => ({type: COMPROBANTE_LIQUIDACION_TYPES.CL_SET_DOCUMENTO_FISICO_EDIT, payload: numeroControl})
const handleErrorsFormDocumentoFisico = (errors: any):ActionCL => ({type: COMPROBANTE_LIQUIDACION_TYPES.CL_HANDLE_ERRORS_DOCUMENTO_FISICO, payload:errors})
const handleErrorsFormCliente = (errors: any):ActionCL => ({type: COMPROBANTE_LIQUIDACION_TYPES.CL_HANDLE_ERRORS_CLIENTE, payload:errors})
const handleErrorsFormProducto = (errors: any):ActionCL => ({type: COMPROBANTE_LIQUIDACION_TYPES.CL_HANDLE_ERRORS_PRODUCTO, payload:errors})
const handleErrorsFormBusquedaDocumento = (errors: any):ActionCL => ({type: COMPROBANTE_LIQUIDACION_TYPES.CL_HANDLE_ERRORS_BUSQUEDA_DOCUMENTO, payload:errors})
const handleCalculosProducto = (calculos: any):ActionCL => ({type: COMPROBANTE_LIQUIDACION_TYPES.CL_SET_CALCULOS_PRODUCTO, payload: calculos})
const handleAddProducto = (productos: any):ActionCL => ({type: COMPROBANTE_LIQUIDACION_TYPES.CL_SET_PRODUCTOS, payload: productos})
const handleRestartFormProducto = ():ActionCL => ({type: COMPROBANTE_LIQUIDACION_TYPES.CL_RESTART_FORM_PRODUCTO, payload: null})
const handleChangeView = (view: string):ActionCL => ({type: COMPROBANTE_LIQUIDACION_TYPES.CL_SET_VIEW, payload: view})
const handleActiveModalQuitarTodo = (active: boolean):ActionCL => ({type: COMPROBANTE_LIQUIDACION_TYPES.CL_ACTIVE_MODAL_QUITAR_TODO, payload: active})
const handleActiveModalEditar = (active: boolean):ActionCL => ({type: COMPROBANTE_LIQUIDACION_TYPES.CL_ACTIVE_MODAL_EDITAR_PRODUCTO, payload: active})
const handleActiveModalEliminar = (active: boolean):ActionCL => ({type: COMPROBANTE_LIQUIDACION_TYPES.CL_ACTIVE_MODAL_ELIMINAR_PRODUCTO, payload: active})
const handleActiveModalEditarDocumentoFisico = (active: boolean):ActionCL => ({type: COMPROBANTE_LIQUIDACION_TYPES.CL_ACTIVE_EDITAR_DOCUMENTO_FISICO, payload: active})
const handleActiveModalEmitir = (active: boolean):ActionCL => ({type: COMPROBANTE_LIQUIDACION_TYPES.CL_ACTIVE_MODAL_EMITIR, payload: active})
const handleActiveModalAgregarDocumentoFisico = (active: boolean):ActionCL => ({type: COMPROBANTE_LIQUIDACION_TYPES.CL_ACTIVE_AGREGAR_DOCUMENTO_FISICO, payload: active})
const handleActiveModalEmitido = (active: boolean):ActionCL => ({type: COMPROBANTE_LIQUIDACION_TYPES.CL_ACTIVE_MODAL_EMITIDO, payload: active})
const handleActiveModalMasOpciones = (active: boolean):ActionCL => ({type: COMPROBANTE_LIQUIDACION_TYPES.CL_ACTIVE_MODAL_MAS_OPCIONES, payload: active})
const handleActiveModalCorreo = (active: boolean):ActionCL => ({type: COMPROBANTE_LIQUIDACION_TYPES.CL_ACTIVE_MODAL_ENVIAR_CORREO, payload: active})
const handleActiveModalImprimir = (active: boolean):ActionCL => ({type: COMPROBANTE_LIQUIDACION_TYPES.CL_ACTIVE_MODAL_IMPRIMIR, payload: active})
const handleActiveModalClienteEncontrado = (active: boolean):ActionCL => ({type: COMPROBANTE_LIQUIDACION_TYPES.CL_ACTIVE_MODAL_CLIENTE_ENCONTRADO, payload: active})
const handleActiveModalAnular = (active: boolean):ActionCL => ({type: COMPROBANTE_LIQUIDACION_TYPES.CL_ACTIVE_MODAL_ANULAR, payload: active})
const handleActiveModalBusquedaDocumentos = (active: boolean):ActionCL => ({type: COMPROBANTE_LIQUIDACION_TYPES.CL_ACTIVE_MODAL_BUSQUEDA_DOCUMENTO, payload: active})
const handleActiveModalAnulado = (active: boolean):ActionCL => ({type: COMPROBANTE_LIQUIDACION_TYPES.CL_ACTIVE_MODAL_ANULADO, payload: active})
const handleSetProductoEdit = (producto: any):ActionCL => ({type: COMPROBANTE_LIQUIDACION_TYPES.CL_SET_PRODUCTO_EDIT, payload: producto})
const handleSetIndexProductoEdit = (index: any):ActionCL => ({type: COMPROBANTE_LIQUIDACION_TYPES.CL_SET_PRODUCTO_INDEX, payload: index})
const handleSetResponseEmitir = (response: any):ActionCL => ({type: COMPROBANTE_LIQUIDACION_TYPES.CL_SET_RESPONSE_EMITIR, payload: response})
const handleSetQRCode = (qr: any):ActionCL => ({type: COMPROBANTE_LIQUIDACION_TYPES.CL_SET_QR_CODE, payload: qr})
export const handleRestarFlujo = ():ActionCL => ({type: COMPROBANTE_LIQUIDACION_TYPES.CL_RESTART_ALL, payload: ''})
const handleSetInfoClienteEncontrado = (info: any):ActionCL => ({type: COMPROBANTE_LIQUIDACION_TYPES.CL_SET_CLIENTE_ENCONTRADO, payload: info})
const handleActiveAsociarDocumentos = (active: boolean):ActionCL => ({type: COMPROBANTE_LIQUIDACION_TYPES.CL_ACTIVE_ASOCIAR_DOCUMENTOS, payload: active})
const handleSetDocumentosEncontrados = (documentos: any):ActionCL => ({type: COMPROBANTE_LIQUIDACION_TYPES.CL_SET_DOCUMENTOS_ENCONTRADOS, payload: documentos})
const handleSetDocumentosAsociados = (documentos: any):ActionCL => ({type: COMPROBANTE_LIQUIDACION_TYPES.CL_SET_DOCUMENTOS_ASOCIADOS, payload: documentos})
const handleActiveLoaderDocumentosAsociados = (active: boolean):ActionCL => ({type: COMPROBANTE_LIQUIDACION_TYPES.CL_SET_LOADER_DOCUMENTOS_ASOCIADOS, payload: active})
const handleActiveModalAdvertenciaAsociarDocumentos = (active: boolean):ActionCL => ({type: COMPROBANTE_LIQUIDACION_TYPES.CL_ACTIVE_ADVERTENCIA_ASOCIAR_DOCUMENTOS, payload: active})
const handleActiveMostrarDetalle = (active: boolean):ActionCL => ({type: COMPROBANTE_LIQUIDACION_TYPES.CL_HANDLE_ACTIVE_MOSTRAR_DETALLE, payload: active})
const handleSetTableProductos = (table: any):ActionCL => ({type: COMPROBANTE_LIQUIDACION_TYPES.CL_SET_TABLE_PRODUCTOS, payload: table})

const api_getSucursales = (body: any) => http.post(ENDPOINTS.GESTION_USUARIO_POST_SUCURSALES, body, {}, KEYS.TOKEN)
const api_RecepcionDTE = (body: any) => http.post(ENDPOINTS.FACTURACION_POST_RECEPCION_DTE, body, {}, KEYS.TOKEN)
const api_buscarCliente = (body: any) => http.post(ENDPOINTS.CLIENTE_RECEPTOR_GUARDAR, body,  {}, KEYS.TOKEN)
const api_buscarDocumentosAsociados = (body: any) => http.post(ENDPOINTS.COMPROBANTE_RETENCION_BUSQUEDA_DTE, body, {}, KEYS.TOKEN)
